export const colors = {
  brand: {
    white: '#FFFFFF',
    blue: '#151D2E',
    yellow: '#EBD800'
  }
}
